import "core-js/modules/es.array.push.js";
//
//
//
//
//
//
//
//
//
//

import GlButton from '@/components/gl-button';
import { utilCookies } from '@/util/cookies';
export default {
  components: {
    GlButton: GlButton
  },
  methods: {
    // 账号登录
    handleLogin: function handleLogin() {
      this.$ga.event('FHRSignup', 'click', 'StartTrial', 5);
      utilCookies.removeCompanyToken();
      this.$router.push({
        path: '/login/loginCompany'
      });
    }
  }
};